{
  "title": "Households",
  "search": "Search",
  "state": "State",
  "archiveHousehold": "Archive Household",
  "editHousehold": "Edit Household",
  "houseHold": "Household",
  "houseHoldChangesOnly": "Household Changes Only",
  "completed": "Profile completed",
  "notCompleted": "Profile not completed",
  "incompleteFields": "Incomplete Fields",
  "allDocumentSigned": "All documents signed",
  "unsignedDocuments_one": "1 unsigned document",
  "unsignedDocuments_other": "{{count}} Unsigned documents",
  "unsignedDocumentsTooltip": "Sign the documents by going to the documents tab.",
  "idVerified": "ID verified",
  "idNotVerified": "ID not verified",
  "idVerificationNotCompletedTooltip": "Add an ID verification inside each member's details tab",
  "complianceApproved": "Compliance Approved",
  "complianceNeedsReview": "Compliance needs review",
  "complianceNeedsReviewTooltip": "Go to the each member's details tab to approve the client’s compliance details",
  "annualInfoUpToDate": "Annual information updated",
  "annualInfoNeedsReview": "Annual information update",
  "annualInfoNeedsReviewTooltip": "Last suitability review took place {{months}}+ months ago. Update the client's information by selecting the edit button on the profile status inside the member's details tab",
  "addModal": {
    "title": "Add new household",
    "name": "Household name",
    "nameRequired": "Household name is required",
    "type": "Household type",
    "primaryUser": "Primary Contact",
    "primaryUserRequired": "Primary contact is required",
    "relationships": "Relationships",
    "add": "Add",
    "searchUser": "Search",
    "createARelation": "Create Relationships",
    "organization": "Organization",
    "relation": "Relation",
    "relationUser": "Relationship user"
  },
  "updateModal": {
    "edit": "Edit",
    "update": "Update",
    "title": "Update household"
  },
  "billingModal": {
    "title": "Update household billing"
  },
  "relationModal": {
    "email": "Email",
    "userEmail": "User email",
    "relationship": "Relationship",
    "affiliationType": "Affiliation type",
    "firstName": "First Name",
    "middleName": "Middle Name",
    "lastName": "Last Name",
    "relationType": "Relationship to Primary Member",
    "permission": "Permission to Household",
    "sin": "Sin",
    "allocation": "Allocation",
    "dateOfBirth": "Date of birth",
    "relationTitle": "Add new relation",
    "updateRelationTitle": "Update Relationship",
    "createAUser": "Create a new user",
    "verifyUser": "Verify user",
    "errorMessage": "No such user. Please click",
    "here": "here",
    "createMessage": "to create a new user.",
    "addRelation": "Add relationship",
    "updateRelation": "Update",
    "removeAffiliate": "Remove Affiliate",
    "removeAffiliateConfirmation": "Are you sure you want to remove affiliate?",
    "organization": "Relation Organization",
    "errorPre": "Please click ",
    "errorPost": " to create a new affiliate",
    "createAffiliate": "Create Affiliate",
    "addAffiliate": "Add Affiliate",
    "createUser": "Create New User",
    "createNewClient": "Create New Client",
    "client": "Client",
    "updateAffiliateTitle": "Update Affiliate"
  },
  "archiveHouseholdConfirmation": {
    "areYouSure": "Are you sure?",
    "thereAreMembers": "There are {{numMembers}} client(s) in this household. This will not delete the client’s information, but they will no longer be associated with this household.",
    "yesSure": "Yes, I’m sure"
  },
  "types": {
    "household": "HOUSEHOLD",
    "business": "BUSINESS"
  },
  "table": {
    "headers": {
      "name": "Household name",
      "contact": "Primary contact",
      "email": "Primary contact Email",
      "relationCount": "Number of Relationships",
      "organization": "Organization",
      "marketValue": "Market Value"
    }
  },

  "summary": {
    "members": "Household Members",
    "primaryContact": "Primary Contact",
    "phone": "Phone",
    "email": "Email",
    "feeGrid": "Fee Grid",
    "billingCycle": "Billing Cycle",
    "feePaymentAccount": "Fee Payment Account",
    "multiple": "Multiple",
    "inheritedDashWhat": "Inherited - {{what}}"
  },
  "tabs": {
    "overview": "Overview",
    "members": "Members",
    "documents": "Documents",
    "statements": "Statements",
    "transfers": "Transfers",
    "ledger": "Ledger",
    "trades": "Trades",
    "notes": "Notes",
    "auditLog": "Audit Log"
  },
  "overview": {
    "totalHouseholdAssets": "Total Household Assets"
  },
  "membersTable": {
    "name": "Name",
    "relationship": "Relationship",
    "phoneNumber": "Phone Number",
    "email": "Email",
    "netWorth": "Net Worth",
    "annualIncome": "Annual Income",
    "status": "Status",
    "marketValue": "Market Value",
    "permissions": "Permissions",
    "editHouseholdMember": "Edit Household Member",
    "removeFromHousehold": "Remove from Household"
  },
  "remove": {
    "accountsExist": "Accounts linked to household exist",
    "thereAreAccountLinked": "{{clientName}} have {{count}} account(s) linked to the household. Dissociate these account(s) first.",
    "areYouSure": "Are you sure you want to remove {{clientName}} from the {{householdName}}?",
    "thisWillNotDelete": "This will not delete the client’s information, but they will no longer be associated with this household.",
    "yesRemove": "Yes, Remove",
    "memberHasBeenRemoved": "Client has been removed from household"
  },
  "removeFromHousehold": {
    "title": "Remove Client from Household",
    "householdName": "Household Name",
    "confirm": "Confirm",
    "error": "You cannot remove the primary owner of a household.",
    "success": "Client has been removed from household"
  },
  "householdStateLabel": "Household State",
  "householdState": {
    "ACTIVE": "Active",
    "ARCHIVED": "Archived"
  },
  "accessTypes": {
    "EDIT": "Full access",
    "VIEW": "Full access",
    "NO_ACCESS": "No access"
  }
}
